import { render, staticRenderFns } from "./PlatePassword.vue?vue&type=template&id=c8f5af28&scoped=true&"
import script from "./PlatePassword.vue?vue&type=script&lang=js&"
export * from "./PlatePassword.vue?vue&type=script&lang=js&"
import style0 from "./PlatePassword.vue?vue&type=style&index=0&id=c8f5af28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f5af28",
  null
  
)

export default component.exports